import { useState } from 'react';

const PortfolioSection = () => {
  const [activeTab, setActiveTab] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Rekrutmen Tenaga Konstruksi',
      category: 'construction',
      image: 'https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Konstruksi Jaya',
    },
    {
      id: 2,
      title: 'Manajemen SDM Pabrik',
      category: 'manufacturing',
      image: 'https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Industri Manufaktur',
    },
    {
      id: 3,
      title: 'Pelatihan Tenaga Administrasi',
      category: 'training',
      image: 'https://images.pexels.com/photos/7173026/pexels-photo-7173026.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Mitra Solusi',
    },
    {
      id: 4,
      title: 'Penyediaan Tenaga IT',
      category: 'technology',
      image: 'https://images.pexels.com/photos/7108/notebook-computer-chill-relax.jpg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Teknologi Terdepan',
    },
    {
      id: 5,
      title: 'Manajemen Tenaga Pemasaran',
      category: 'sales',
      image: 'https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Distribusi Global',
    },
    {
      id: 6,
      title: 'Konsultasi Reorganisasi SDM',
      category: 'consulting',
      image: 'https://images.pexels.com/photos/3182781/pexels-photo-3182781.jpeg?auto=compress&cs=tinysrgb&w=1600',
      client: 'PT Sukses Mandiri',
    },
  ];

  const filteredProjects = activeTab === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeTab);

  return (
    <section className="py-20">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
            Portofolio Kami
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
            Berikut adalah beberapa proyek dan industri yang telah kami layani dengan solusi tenaga kerja terbaik.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {[
            { id: 'all', label: 'Semua' },
            { id: 'construction', label: 'Konstruksi' },
            { id: 'manufacturing', label: 'Manufaktur' },
            { id: 'training', label: 'Pelatihan' },
            { id: 'technology', label: 'Teknologi' },
            { id: 'consulting', label: 'Konsultasi' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-2 rounded-md font-medium transition-all ${
                activeTab === tab.id
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Project Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div key={project.id} className="card group">
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-navy-900/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <button className="px-6 py-2 bg-yellow-500 text-white rounded-md transform translate-y-8 group-hover:translate-y-0 transition-transform duration-300">
                    Lihat Detail
                  </button>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 text-navy-900 group-hover:text-primary-600 transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-2">Klien: {project.client}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;